export function scheduledDate(order) {
  const v = order?.scheduledFor;
  if (!v) return null;
  const d = typeof v.toDate === 'function' ? v.toDate() : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function scheduledLabel(order) {
  const d = scheduledDate(order);
  if (!d) return '';
  return d.toLocaleString('tr-TR', {
    timeZone: 'Europe/Istanbul', weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}
